import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
//FB 6264
import {
  Grid,
  Typography,
  Button,
  createMuiTheme,
  ThemeProvider,
  TextField,
  Tooltip,
  Fab,
  CircularProgress,
} from "@material-ui/core";
import { Context, Facility, Provider } from "../store";
import { modify_AppointmentDetails } from "../actions";
import { useHistory } from "react-router-dom";
import useStyles from "../css/styles";
import { Autocomplete } from "@material-ui/lab";
import {
  GetAvailableSlotsByDate,
  GetFacilityProviders,
  GetLocationsByDate,
  InsertPELogs
} from "../api"; //FB 4960
import { format } from "date-fns";
import RefreshIcon from "@material-ui/icons/Replay";
import globalsettings from "../../../config"; //FB 4960

// update log
// FB 4371 DK    03/29/2021    Added for By Date screen of inoffice workflow
// FB 4574 DK    07/15/2021    Added styling for dropdown icons
// FB 4769 MS    11/02/2021    Added Job Title info for provider
// FB 4774 DK    11/18/2021    Message changes
// FB 4867 DK    01/20/2022    Phone numbe made clickable
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 6361 DK	   01/03/2023    Employee Bio missing on ByDate workflow
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 8796 KI    06/23/20234   Auto selecting location and provider if we have only one data
// FB 9135 MS    07/22/2024    Show unavailable message when there is no slots
// FB 9597 DK    10/24/2024    Schedules not loading on PE
// FB 9560 DK    11/29/2024    Location field should be hidden in the PE when no scheduler is available for the selected date in the By date flow.

export default function Datepage(props: any) {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });

  const { state, dispatch } = useContext(Context);
  const styles = useStyles();
  const [providers, setProviders] = React.useState<Provider[]>([]);
  //FB-6264
  const [providersopen, setProvidersOpen] = React.useState(false);
  const providersLoader = providersopen && providers.length === 0;
  const [selectedprovider, SetSelectedProvider] = useState<Provider>({
    id: 0,
    name: "",
    bio: "",	//FB 6361
    job_title: "", //FB 4769
  });

  const [facilities, setFacilities] = React.useState<Facility[]>([]);
  //FB-6264
  const [facilitiesopen, setFacilitiesOpen] = React.useState(false);
  const facilitiesLoader = facilitiesopen && facilities.length === 0;
  const [selectedfacility, SetSelectedfacility] = useState<Facility>(
    state.appointmentdetails.location
  );

  const [selectedDate, setSelectedDate] = useState(
    state.appointmentdetails.date
  );

  const [availableSlots, setAvailableSlots] = useState<number>();
  const [isDisabled, setIsDisabled] = useState(false);

  //FB 4371 DK    Added to refresh the selected options
  //FB 4960
  const resetForm = () => {
    SetSelectedProvider({ id: 0, name: "", job_title: "" }); //FB 4769
    SetSelectedfacility({ id: 0, name: "", address: "", region: 0, phone: "" });   //FB 4774 DK - Added phone
    setSelectedDate(new Date());
    state.appointmentdetails.date = new Date();
    GetLocationsByDate(
      format(selectedDate, "MM-dd-yyyy"),
      state.appointmentdetails.insurance.id
    ).then((data) => {
      setFacilities(data);
    });
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Click on Reset");
    //FB 4960 End
  };

  //FB 4371 DK    Added to refresh the facility list when date is changed
  useEffect(() => {
    SetSelectedProvider({ id: 0, name: "", job_title: "" }); //FB 4769
    SetSelectedfacility({ id: 0, name: "", address: "", region: 0, phone: "" });   //FB 4774 DK - Added phone

    GetLocationsByDate(
      format(selectedDate, "MM-dd-yyyy"),
      state.appointmentdetails.insurance.id
    ).then((data: any) => { //FB 8796
      setFacilities(data);
      setAvailableSlots(data.length); //FB 9135
      //FB 8796
      if (data.length == 1) {
        SetSelectedfacility(data[0]);
      }
    });
  }, [selectedDate]);

  //FB 4371 DK    Added to refresh the available slots count on change of date
  useEffect(() => {
    let splittedDate = selectedDate.toLocaleDateString().split("/");
    let date = splittedDate[0] + "-" + splittedDate[1] + "-" + splittedDate[2];
    GetAvailableSlotsByDate(date, 0, 0).then((data) => {
      //FB 9560
      //setAvailableSlots(data.length);
    });
  }, [selectedDate]);

  //FB 4371 DK    Added to refresh the provider list when facility is changed
  useEffect(() => {
    //FB 9597
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");//FB 7801
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;
    if (selectedfacility.id > 0) {
      SetSelectedProvider({ id: 0, name: "", job_title: "" }); //FB 4769
      GetFacilityProviders(
        format(selectedDate, "MM-dd-yyyy"),
        selectedfacility.id,
        state.appointmentdetails.insurance.id,//FB  7801
        appt_type_n //FB  7801
      ).then((data: any) => { 	//FB 8796
        setProviders(data);
        //FB 8796
        if (data.length == 1) {
          SetSelectedProvider(data[0]);
        }
      });
    }
  }, [selectedfacility]);

  //FB 4867 DK - Removed unused code

  //FB 4371 DK    Added to show display message of slots unavailablility at specific location on selected date
  useEffect(() => {
    if (selectedfacility.id != 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [selectedfacility]);

  useEffect(() => {
    state.appointmentdetails.provider = { id: 0, name: "" };
  }, [selectedDate]);

  //FB 4371 DK    Added to modify state when the selected provider is changed
  //FB 4960
  const handleProviderChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedProvider(value as Provider);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Choosed the provider " + value.name);
      //FB 4960 End
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: state.appointmentdetails.insurance,
          appointmentfilter: state.appointmentdetails.appointmentfilter,
          provider: value,
          location: state.appointmentdetails.location,
          date: state.appointmentdetails.date,
        },
        dispatch
      );
    } else {
      SetSelectedProvider({
        name: "",
        id: 0,
        job_title: "", //FB 4769
      });
    }
  };

  //FB 4371 DK    Added to modify state when the selected facility is changed
  //FB 4960
  const handleLocationChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedfacility(value as Facility);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Choosed the location " + value.name);
      //FB 4960 End
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: state.appointmentdetails.insurance,
          appointmentfilter: state.appointmentdetails.appointmentfilter,
          provider: state.appointmentdetails.provider,
          location: {
            id: value.id,
            name: value.name,
            address: value.address,
            phone: value.phone,   //FB-4867
            region: state.appointmentdetails.location.region,
          },
          date: state.appointmentdetails.date,
        },
        dispatch
      );
    } else {
      SetSelectedfacility(state.appointmentdetails.location);
    }
  };

  //FB 4371 DK    Added to modify state when the selected date is changed
  //FB 4960
  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Changed the date to " + date.toDateString());
      //FB 4960 End
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: state.appointmentdetails.insurance,
          appointmentfilter: state.appointmentdetails.appointmentfilter,
          provider: state.appointmentdetails.provider,
          location: state.appointmentdetails.location,
          date: date,
        },
        dispatch
      );
    }
  };

  //FB 4960
  const handleGoback = () => {
    props.onCallbackType("");
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on go back - by date");
    //FB 4960 End
  };

  const history = useHistory();

  //FB 4371 DK    Added to navigate to slots page
  //FB 4960
  const handleProceed = () => {
    //let fac = facilities.find((facility) => (facility.id = 7));
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by date");
    //FB 4960 End
    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
        patientType: state.appointmentdetails.patientType,
        isInsuranceExist: state.appointmentdetails.isInsuranceExist,
        insurance: state.appointmentdetails.insurance,
        appointmentfilter: state.appointmentdetails.appointmentfilter,
        provider: state.appointmentdetails.provider,
        location: selectedfacility,
        date: state.appointmentdetails.date,
      },
      dispatch
    );
    history.push("/slots_bydate", state);
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div ref={scrollTo}>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          direction="row"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography id="selectDate" variant="h6">
            Please select the date
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={2}>
        {/* <Grid item xs={12} sm={6} md={3} direction="row" style={{display:"flex",alignItems:"flex-end"}}> */}
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          direction="row"
          style={{ marginTop: 15 }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                className={styles.datepickerroot}
                id="selectDateSlotsPage"
                style={{ width: "-webkit-fill-available" }}
                inputVariant="standard"
                orientation={window.innerWidth > 768 ? "landscape" : "portrait"}
                value={selectedDate}
                onChange={(date) => handleDateChange(date)}
                format="MM/dd/yyyy"
                minDate={new Date()}
                minDateMessage="Date should not be in past"
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
        {/* FB 9560 */}
        <Grid item xs={12} sm={6} md={3} style={{ display: availableSlots === 0 ? "none" : "block" }}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              disableClearable
              id="facilitylist"
              className={styles.dropdown_nomargin}
              //style={{ width: "-webkit-fill-available" }}
              value={selectedfacility}
              onChange={handleLocationChange}
              getOptionLabel={(option) => option.name}
              groupBy={(option) =>
                option.InsuranceAcceptance &&
                  state.appointmentdetails.isInsuranceExist === "Yes"
                  ? option.InsuranceAcceptance
                  : ""
              }
              options={facilities}
              //FB-6264
              open={facilitiesopen}
              loading={facilitiesLoader}
              onOpen={() => {
                setFacilitiesOpen(true);
              }}
              onClose={() => {
                setFacilitiesOpen(false);
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              // FB 4574 DK - Added class to increase the icon size
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location*"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      //FB-6264
                      <React.Fragment>
                        {facilitiesLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4} //FB 4769
          style={{ display: selectedfacility.id > 0 ? "block" : "none" }}
        >
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="providerlist"
              className={styles.dropdown_nomargin}
              value={selectedprovider}
              onChange={handleProviderChange}
              getOptionLabel={(option) => option.job_title != "" && option.job_title != undefined ? option.name + " (" + option.job_title + ")" : option.name} //FB 4769
              groupBy={(option) =>
                option.InsuranceAcceptance &&
                  state.appointmentdetails.isInsuranceExist === "Yes"
                  ? option.InsuranceAcceptance
                  : ""
              }
              options={providers}
              //FB-6264
              loading={providersLoader}
              open={providersopen}
              onOpen={() => {
                setProvidersOpen(true);
              }}
              onClose={() => {
                setProvidersOpen(false);
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              // FB 4574 DK - Added class to increase the icon size
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider(optional)"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      //FB-6264
                      <React.Fragment>
                        {providersLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
        {window.innerWidth < 768 ? (
          <Grid
            item
            xs={12}
            style={{
              marginTop: -5,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Tooltip title="Reset">
              <Fab
                size="small"
                className={styles.fabButton}
                onClick={resetForm}
              >
                <RefreshIcon />
              </Fab>
            </Tooltip>
          </Grid>
        ) : (
          <Grid item md={1} style={{ marginTop: -5 }}>
            <Tooltip title="Reset">
              <Fab
                size="small"
                className={styles.fabButton}
                onClick={resetForm}
              >
                <RefreshIcon />
              </Fab>
            </Tooltip>
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        style={{ display: availableSlots === 0 ? "flex" : "none" }}
      >
        <Grid item xs={12}>
          <Typography variant="h6" style={{ color: "red" }}>
            No appointments available for the selected date. Please select
            another date.
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        alignContent="flex-end"
        justify="flex-end"
        style={{ marginTop: 25 }}
      >
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            id="showSchedule"
            className={styles.navigationButton}
            onClick={handleProceed}
            disabled={isDisabled}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            onClick={handleGoback}
            id="goBackDate"
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
